import React from 'react';
import ReactDOM from 'react-dom';

import dataLoaded from 'data/load';
import Store from 'store';

import makeGameTips from './gametips';
import Paperdoll from './Paperdoll';

//import './App.scss';
import { profileFix } from 'logic/profileReducers';
import { getApiPath, getProfilePath } from 'common';
import makeItemTable from './itemTable';
import { AltarEmbed } from 'components/paragon/Altar';

async function _loadProfile(id) {
  const url = getApiPath(`profiles/d3/${id}`);
  const result = await fetch(url).then(response => response.json());

  if (!result || result.error || !result.data) {
    throw Error(result?.error || `Unknown error`);
  }

  await dataLoaded;
  return JSON.parse(result.data);
}

const buildCache = {};
function getBuild(id) {
  if (buildCache[id]) return buildCache[id];
  return buildCache[id] = _loadProfile(id);
}

const Error = ({ text }) => <div className="d3p-error">{text}</div>;

function Embed({ scale, type, href }) {
  scale = parseFloat(scale);
  const style = {display: "inline-block", align: "center"}, innerStyle = {};

  const defaultSize = { width: 360, height: 632 };
  if (type === 'altar') {
    defaultSize.width = 340;
    defaultSize.height = 463;
  }

  if (!isNaN(scale)) {
    innerStyle.transformOrigin = "top left";
    innerStyle.transform = `scale(${scale})`;
    style.boxSizing = "border-box";
    style.width = `${(defaultSize.width * scale).toFixed(0)}px`;
    style.height = `${(defaultSize.height * scale).toFixed(0)}px`;
    style.overflow = "hidden";
  }

  return (
    <div style={style}>
      {type === 'altar' ? (
        <AltarEmbed style={innerStyle} href={href}/>
      ) : (
        <Paperdoll style={innerStyle} href={href}/>
      )}
    </div>
  );
}

function getProfile(data, name) {
  if (data.profiles) {
    return (name && (data.profiles[name] || data.profiles.find(p => p.name === name))) || data.profiles[0];
  } else {
    return data;
  }
}

async function renderProfile(href, profile, scale, type, node) {
  await dataLoaded;
  const store = new Store();
  await store.setState({
    profiles: [profileFix(profile)],
    activeProfile: 0,
    active: {},
  });

  ReactDOM.render((
    <Store.Provider store={store}>
      <Embed scale={scale} type={type} href={href}/>
    </Store.Provider>
  ), node);
}

document.addEventListener("DOMContentLoaded", () => {
  const elements = document.querySelectorAll(".d3planner-build");
  for (const el of elements) {
    const id = el.getAttribute("data-d3planner-id");
    if (id.match(/^\d+$/)) {
      getBuild(id).then(data => {
        if (data.error || (!data.profiles?.length && !data.class)) {
          ReactDOM.render(<Error text={data.error || "Failed to load profile"}/>, el);
        } else {
          const type = el.getAttribute("data-d3planner-type");
          const profile = getProfile(data, el.getAttribute("data-d3planner-set"));
          let href = getProfilePath(id);
          if (data.profiles && data.profiles.length > 1) {
            href += "#" + encodeURIComponent(profile.name);
          }
          if (profile && profile.class) {
            renderProfile(href, profile, el.getAttribute("data-d3planner-scale"), type, el);
          }
        }
      }).catch(() => ReactDOM.render(<Error text="Failed to load profile"/>, el));
    }
  }

  dataLoaded.then(() => {
    makeGameTips();
    makeItemTable();
  });
});
